module.exports = __webpack_public_path__ + "img/products3.f52d2900.svg";